import { APP_TITLE } from '@/consts';
import { defineStore } from 'pinia';

import {
  getCssVar,
  colorIsDark,
  lighten,
  setCssVar,
  humpToUnderline,
  hexToRGB,
  mix,
} from '@/utils';

export const useAppStore = defineStore(
  'app.store',
  () => {
    const useApp = reactive({
      title: '', // 标题
      logo: true, // logo
      theme: {},
      mytopbg: '',
      cardIdActive: '',
      passphraseInfo: {},
      location: null, // 用户位置
      popAd: '',
      showPopAd: false,
      userInfo: {},
      ads: [], // 广告
    });

    const setSetting = (setting) => {
      const { name, logo, ui } = setting;
      useApp.title = name;
      useApp.logo = logo;
      useApp.mytopbg = ui.mytopbg;
      setTheme(ui); // 设置主题
      document.title = useApp.title;
    };

    const setAds = (ads) => {
      useApp.ads = ads;
    };

    const setPrimaryTheme = (color) => {
      setTheme({ elColorPrimary: color });
    };
    const setTheme = (theme) => {
      useApp.theme = Object.assign(useApp.theme, theme);
      setCssVarTheme();
    };
    const setCssVarTheme = () => {
      let s= '';
      for (const key in useApp.theme) {
        if (key !== 'mytopbg') {
          s += `--ldzc-${humpToUnderline(key)}: ${useApp.theme[key]};\n`;
          setCssVar(`--ldzc-${humpToUnderline(key)}`, useApp.theme[key]);
        }
      }
      console.log(s);

      setCardBGColor();
    };

    const setCardBGColor = () => {
      const color = getCssVar('--ldzc-highlight-bg-sub-color').value;
      let op = parseInt(getCssVar('--ldzc-card-bg-num').value || 0);
      if (op < 1) {
        op = 1;
      }
      setCssVar(
        `--ldzc-highlight-bg-sub-color-unselected`,
        hexToRGB(color, 0.1 * op)
      );
    };

    const setUserLocation = (location) => {
      useApp.location = location;
    };

    const setPassphraseInfo = (passphraseInfo) => {
      useApp.passphraseInfo = passphraseInfo;
    };

    const setCardIdActive = (cardId) => {
      useApp.cardIdActive = cardId;
    };
    const setPopAd = (url) => {
      if (useApp.popAd != url) {
        useApp.popAd = url;
        setTimeout(() => {
          useApp.showPopAd = true;
        }, 500);
      }
    };

    const setUserInfo = (userInfo) => {
      useApp.userInfo = userInfo;
    };

    return {
      useApp,
      setTheme,
      setPrimaryTheme,
      setCssVarTheme,
      setUserLocation,
      setSetting, // 设置设置
      setPassphraseInfo,
      setCardIdActive,
      setPopAd,
      setAds,
      setUserInfo,
    };
  },
  { persist: true }
  // {
  //   persist: {
  //     key: 'store.key.app',
  //     storage: window.localStorage,
  //   },

  // }
);
